import {Proxy} from "../../../settings";
import {baseDeleteRequest} from "../base/baseDeleteRequest";

const deleteLogout = (session_key: string) => baseDeleteRequest(`${Proxy}/session/`, {session_key})

export default deleteLogout;
